let loginDataGlobal = null;
export function setLoginDataGlobal(data) { loginDataGlobal = data; }
export function getLoginDataGlobal() {   return loginDataGlobal; }